module.exports = __webpack_public_path__ + "img/inspiration_01.1febcc9.jpg";